import { api } from "../../../utils";
const { stored } = api.net.config;
const cafe = {
    default: {
        href: "/",
    },
};
const df = cafe.default;

const loadData = async ({ rootState, state, commit, dispatch }, payload) => {
    let resolve;
    let PageUrl = "#";
    let p = new Promise(r => resolve = r);
    let ua = rootState.useragent;
    let { headers } = ua;
    if (typeof (payload) === "object") PageUrl = payload.href; else PageUrl = headers.href || df.href;
    let page = state.detail[PageUrl];
    if (!page) {
        console.log("views.pages.loadData", PageUrl);
        let filter = { PageUrl };
        let res = await api.net.data.bot.load.list({ storeName: stored.GetPageInfor, filter });
        if (res && res.isSuccess) {
            page = res.data[0];
            try {
                page.PageBreadcrumbs = JSON.parse(page.PageBreadcrumbs);
            } catch (error) {
            };
            state.detail[PageUrl] = page;
            commit({ type: "loadData", data: state });
        };
    };
    resolve(page);

    return p;
};

export default {
    loadData,
};



// WEBPACK FOOTER //
// src/store/views/pages/actions.js